var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureTerrace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1972",
    "data-name": "Group 1972",
    transform: "translate(261.5 -1033.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(-261 1034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M-212.049,1043.274l-1.605-1.605-.116-.116-7.428-7.428a.4.4,0,0,0-.582,0l-7.195,7.2-7.195-7.2a.4.4,0,0,0-.582,0l-7.195,7.2-7.195-7.2a.4.4,0,0,0-.582,0l-7.428,7.428-.116.116-1.605,1.605a.4.4,0,0,0,0,.582.4.4,0,0,0,.582,0l.957-.957v10.647a.412.412,0,0,0,.416.416h4.991a.412.412,0,0,0,.416-.416v-7.07h4.159v7.07a.412.412,0,0,0,.416.416h9.981a.412.412,0,0,0,.416-.416v-7.07h4.159v7.07a.412.412,0,0,0,.416.416h9.981a.412.412,0,0,0,.416-.416v-7.07h4.159v7.07a.412.412,0,0,0,.416.416H-214a.412.412,0,0,0,.416-.416V1042.9l.957.957a.39.39,0,0,0,.291.125.39.39,0,0,0,.291-.125A.4.4,0,0,0-212.049,1043.274Zm-32.315,9.857h-4.159v-7.07a.412.412,0,0,0-.416-.416h-4.991a.412.412,0,0,0-.416.416v7.07H-258.5v-11.063l7.07-7.062,6.9,6.9.166.166Zm14.972,0h-4.159v-7.07a.412.412,0,0,0-.416-.416h-4.991a.412.412,0,0,0-.416.416v7.07h-4.159v-11.063l.166-.166,6.9-6.9,6.9,6.9.166.166Zm14.972,0h-4.159v-7.07a.412.412,0,0,0-.416-.416h-4.991a.412.412,0,0,0-.416.416v7.07h-4.159v-11.063l.166-.166,6.9-6.9,7.07,7.062Z",
    transform: "translate(261 -1034)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M-243.86,1042.272v11.063h-4.159v-7.07a.412.412,0,0,0-.416-.416h-4.991a.412.412,0,0,0-.416.416v7.07H-258v-11.063l7.07-7.062,6.9,6.9Z",
    transform: "translate(260.495 -1034.203)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M-207.86,1042.272v11.063h-4.159v-7.07a.412.412,0,0,0-.416-.416h-4.991a.412.412,0,0,0-.416.416v7.07H-222v-11.063l.166-.166,6.9-6.9Z",
    transform: "translate(254.44 -1034.203)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M-225.86,1042.272v11.063h-4.159v-7.07a.412.412,0,0,0-.416-.416h-4.991a.412.412,0,0,0-.416.416v7.07H-240v-11.063l.166-.166,6.9-6.9,6.9,6.9Z",
    transform: "translate(257.468 -1034.203)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    transform: "translate(-244.531 1041.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M-240.967,1043.22a.448.448,0,0,0-.067.233v.166l-.166-.166Z",
    transform: "translate(241.2 -1042.871)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M-240.314,1043.033a.447.447,0,0,0-.233-.067.447.447,0,0,0-.233.067l.233-.233Z",
    transform: "translate(241.129 -1042.8)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M-240.013,1043.619v-.166a.448.448,0,0,0-.067-.233l.233.233Z",
    transform: "translate(241.012 -1042.871)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M-222.967,1043.22a.448.448,0,0,0-.067.233v.166l-.166-.166Z",
    transform: "translate(238.172 -1042.871)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M-222.013,1043.619v-.166a.448.448,0,0,0-.067-.233l.233.233Z",
    transform: "translate(237.984 -1042.871)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTerrace);
export default __webpack_public_path__ + "static/media/feature-terrace.673830d02237372849ae3b56beab8b66.svg";
export { ForwardRef as ReactComponent };